import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IinsPlanWithPremiums,
  IInsuranceSearchData,
} from "commonFnBcode/types/insurance.types";
import { IInsurancePlan } from "commonFnBcode/types/insuranceTypes";
import { IinsPassengerFormData } from "commonFnBcode/zod/insurance.zod";

const initialState: {
  selectedPlan?: IInsurancePlan | undefined;
  searchData?: IInsuranceSearchData;
  passengerDetails?: IinsPassengerFormData;
} = {};

const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  reducers: {
    setSelectedPlanAndSearchData: (
      state,
      action: PayloadAction<{
        selectedPlan: IInsurancePlan;
        searchData: IInsuranceSearchData;
      }>
    ) => {
      state.selectedPlan = action.payload.selectedPlan;
      state.searchData = action.payload.searchData;
    },
    setPassengerDetails: (
      state,
      action: PayloadAction<IinsPassengerFormData>
    ) => {
      state.passengerDetails = action.payload;
    },
  },
});

export const INSURANCE_ACTIONS = insuranceSlice.actions;

export const insuranceReducer = insuranceSlice.reducer;
